import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { LeavesAll } from '../types';
import {isAfter, isBefore} from 'date-fns';
import { parseAndChangeDate } from '../utils/functions';
class LeavesPerYear {
  leavesAll:LeavesAll[] = [];
  isFetchedLeavesPerYear = false;
 
  getLeavesAll = async (year?: number, userId?: number) => {
    try {
      this.isFetchedLeavesPerYear = false;
      const leaves = await apiConfig.requestService.getLeavesAll(year, userId);
        
      const sortedLeaves = [...leaves]
        .sort((a, b) => {
          const dateA = parseAndChangeDate(a);
          const dateB = parseAndChangeDate(b);
            
          if (isAfter(dateA, dateB)) return -1; 
          if (isBefore(dateA, dateB)) return 1;
          return 0;
        });
      
      const relocationIndex = sortedLeaves.findIndex(
        leave => leave.isPeriodBeforeRelocation
      );  
        
      if (relocationIndex > -1) {
        const [relocationLeave] = sortedLeaves.splice(relocationIndex, 1);
        sortedLeaves.push(relocationLeave);
      }
       
      this.leavesAll = sortedLeaves;        
        
      setTimeout(()=> {
        this.isFetchedLeavesPerYear = true;
      }, 300);
    }
    catch (e) {
      this.isFetchedLeavesPerYear = false;
    }
  };
  cancelPlannedRequest = async (startDate: string, endDate: string, callback: () => void) => {
    await apiConfig.requestService.cancelPlannedRequest(startDate, endDate);
    callback();
  };
  constructor() {
    makeAutoObservable(this);
  }
}

export const LeavesPerYearStore = new LeavesPerYear();